import React, { FC, useEffect } from "react";
import Button from "../Button/Button";
import Close from "../../assets/img/close.svg";
import "./Modal.scss";
import { useComponentVisible } from "../../utils/functions";
import getClasses from "../../utils/getClasses";

export interface ModalProps {
  close?: () => void;
  children: JSX.Element;
  open: boolean;
  classWrapper?: string;
}
const Modal = ({ close, children, open, classWrapper }: ModalProps) => {
  const multiClick = () => {
    setIsComponentVisible(false);
    close && close();
  };

  const { ref, setIsComponentVisible, isComponentVisible } =
    useComponentVisible(open);

  useEffect(() => {
    !isComponentVisible && close && close();
  }, [isComponentVisible, close]);

  return (
    <div className="container__modal">
      <div
        ref={ref}
        className={`modal-wrapper ${classWrapper}`}
      >
        <div className="header">
          <button
            onClick={multiClick}
            type="button"
            aria-label="Close fullscreen"
            title="Close fullscreen"
            className="close-fullscreen"
          >
            <svg width="100%" height="100%" className="icon">
              <use xlinkHref={`${Close}#close`} href={`${Close}#close`}></use>
            </svg>
          </button>
        </div>

        {children}
      </div>
    </div>
  );
};

export default Modal;
